/**
 * 租户管理相关 API（对接 tRPC 后端 trpc.samples.deeptutor.Admin）
 */
import { http } from '@/utils';

// API Endpoints
const Api = {
    List: '/ListTenants',
    Create: '/CreateTenant',
    Update: '/UpdateTenant',
    Delete: '/DeleteTenant',
};

/**
 * 分页查询租户
 */
export async function listTenants(
    params: API.ListTenantsReq,
): Promise<API.ListTenantsRsp> {
    const response = await http.post<API.ListTenantsRsp>(Api.List, params);
    return response?.Data || { Total: 0, Items: [] };
}

/**
 * 新建租户
 */
export async function createTenant(
    params: API.CreateTenantReq,
): Promise<API.TenantInfo> {
    const response = await http.post<API.TenantInfo>(Api.Create, params);
    return response?.Data || {};
}

/**
 * 更新租户
 */
export async function updateTenant(
    params: API.UpdateTenantReq,
): Promise<API.TenantInfo> {
    const response = await http.post<API.TenantInfo>(Api.Update, params);
    return response?.Data || {};
}

/**
 * 删除租户（软删除）
 */
export async function deleteTenant(params: API.DeleteTenantReq): Promise<void> {
    await http.post(Api.Delete, params);
}
